import { render, staticRenderFns } from "./CreateShopWizard.vue?vue&type=template&id=dfb4ee5a&"
import script from "./CreateShopWizard.vue?vue&type=script&lang=js&"
export * from "./CreateShopWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports